import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { Button, Input, InputNumber, Form, Space, notification, Switch } from 'antd';

import FormHeader from '@controls/form-header/form-header';

import { exception } from '@extensions/notification';
import { Permission, hasPermission } from '@enums/permission';

import { userLoaded } from '@store/actions';
import { useAppSelector, useAppDispatch } from '@store/hooks';

import { serverFetch } from '@flc/server';

import { IUserSession } from '@entities/user-session';
import { IPackageTemplate } from '@entities/package-template';

const PackageTemplate = () => {
    const { id } = useParams();

    const navigate = useNavigate();
    const [api, contextHolder] = notification.useNotification();

    const d = useAppDispatch();
    const userSession = useAppSelector<IUserSession>((s) => s.userSession);

    const [entity, setEntity] = useState<IPackageTemplate>({
        id: undefined,
        name: undefined,
        qtyPerPallet: undefined,
        usePrice: true,
    });
    const [loading, setLoading] = useState<boolean>(false);
    const [managePackageTemplate] = useState<boolean>(hasPermission(userSession.permissions, Permission.ManagePackageTemplates));

    useEffect(() => {
        initData();
    }, []);

    const initData = () => {
        if (!id) {
            return;
        }

        setLoading(true);

        serverFetch(`packagetemplates/${id}`, { method: 'GET' })
            .then((data) => {
                setEntity(data);
                setLoading(false);
            })
            .catch((ex) => {
                exception(api, 'Ошибка получения упаковки', ex, () => d(userLoaded(undefined)));
                setLoading(false);
            });
    };

    const onSave = () => {
        setLoading(true);

        serverFetch(`packagetemplates`, { method: id ? 'PUT' : 'POST', bodyData: entity })
            .then(() => {
                setLoading(false);
                navigate(-1);
            })
            .catch((ex) => {
                setLoading(false);
                exception(api, 'Ошибка сохранения упаковки', ex, () => d(userLoaded(undefined)));
            });
    };

    return (
        <>
            <FormHeader title={`${id ? (!managePackageTemplate ? 'Информация об упаковке' : 'Изменить упаковку') : 'Добавить упаковку'}`} />
            {!loading && (
                <Form colon={false} labelCol={{ span: 5 }} wrapperCol={{ span: 8 }} onFinish={onSave}>
                    <Form.Item
                        initialValue={entity?.name}
                        required
                        label='Название'
                        name='name'
                        rules={[{ required: true, message: 'Укажите название упаковки' }]}
                    >
                        <Input
                            disabled={!managePackageTemplate}
                            autoFocus
                            onChange={(data) => {
                                setEntity({ ...entity, name: data.target.value });
                            }}
                        />
                    </Form.Item>
                    <Form.Item required label='На палете'>
                        <Space.Compact>
                            <Form.Item
                                noStyle
                                initialValue={entity?.qtyPerPallet}
                                name='qtyPerPallet'
                                rules={[{ required: true, message: 'Укажите количество упаковок на палете' }]}
                            >
                                <InputNumber
                                    disabled={!managePackageTemplate}
                                    onChange={(value: number | null) => {
                                        setEntity({ ...entity, qtyPerPallet: value });
                                    }}
                                />
                            </Form.Item>
                            <Space.Addon>шт</Space.Addon>
                        </Space.Compact>
                    </Form.Item>
                    <Form.Item label='Длина'>
                        <Space.Compact>
                            <Form.Item initialValue={entity?.height} name='length' noStyle>
                                <InputNumber
                                    disabled={!managePackageTemplate}
                                    onChange={(value: number | null) => {
                                        setEntity({ ...entity, length: value });
                                    }}
                                />
                            </Form.Item>
                            <Space.Addon>см</Space.Addon>
                        </Space.Compact>
                    </Form.Item>
                    <Form.Item label='Ширина'>
                        <Space.Compact>
                            <Form.Item initialValue={entity?.height} name='width' noStyle>
                                <InputNumber
                                    disabled={!managePackageTemplate}
                                    onChange={(value: number | null) => {
                                        setEntity({ ...entity, width: value });
                                    }}
                                />
                            </Form.Item>
                            <Space.Addon>см</Space.Addon>
                        </Space.Compact>
                    </Form.Item>
                    <Form.Item label='Высота'>
                        <Space.Compact>
                            <Form.Item initialValue={entity?.height} name='height' noStyle>
                                <InputNumber
                                    disabled={!managePackageTemplate}
                                    onChange={(value: number | null) => {
                                        setEntity({ ...entity, height: value });
                                    }}
                                />
                            </Form.Item>
                            <Space.Addon>см</Space.Addon>
                        </Space.Compact>
                    </Form.Item>
                    <Form.Item
                        label='Автоматический расчет стоимости'
                        initialValue={entity?.usePrice}
                        valuePropName='checked'
                        name='usePrice'
                        wrapperCol={{ span: 2 }}
                    >
                        <Switch
                            disabled={!managePackageTemplate}
                            onChange={(value) => {
                                setEntity({ ...entity, usePrice: value });
                            }}
                        />
                    </Form.Item>
                    <Form.Item label='' wrapperCol={{ offset: 3, span: 8 }}>
                        <Space size={'small'} style={{ float: 'right' }}>
                            <Button type='text' onClick={() => navigate(-1)}>
                                Отменить
                            </Button>
                            {managePackageTemplate && (
                                <Button type='primary' htmlType='submit' loading={loading}>
                                    Сохранить
                                </Button>
                            )}
                        </Space>
                    </Form.Item>
                </Form>
            )}

            {contextHolder}
        </>
    );
};

export default PackageTemplate;
